/*
|--------------------------------------------------------------------------
| Users management features and utilities composable
|--------------------------------------------------------------------------
|
| This composable JS file contains all common properties and methods
| used in the different views or components for the Users management
| of the application.
*/

// Import Vue.js Framework functions
import { reactive } from 'vue'
import { computed } from 'vue'

// Import librairies
//import axios from 'axios'

// import own utility function library
import useCrudComp from './useCrudComp.js'
import useErrorsComp from '@/composables/useErrorsComp.js'
import useArrayUtilsComp from '@/composables/useArraysUtilsComp.js'

export default function useUsersComp() {

    // define variable with the needed utils functions
    const useCrud = useCrudComp()
    const useErrors = useErrorsComp()
    const useArrayUtils = useArrayUtilsComp()


    // define the reactive variables
    const state = reactive({

        form: {
            body: {
                id: null,
                name: '',
                email: '',
                password: '',
                role: 0,
            },
            show_password: false,
            options: [
                { text: '0: New', value: 0 },
                { text: '1: User', value: 1 },
                { text: '2: Master', value: 2 },
                { text: '3: Admin', value: 3 },
            ],

            status: null,   // this point has to be improved ! !
            resources: null,
            loading: true,

            response: {
                message: null,
                alert: null,
            }

        },

        pagination: {
            meta: {
                currentPage: 0,
                from: 0,
                lastPage: 0,
                perPage: 0,
                to: 0,
                total: 0,
                requestQtyPerPage: 0,
                requestedPage: 0,
            },
            links: {
                prev: null,
                next: null,
            },
        },

        checkedUsers: [0,1],

        selectedUsers : computed(() => {
            let length = state.checkedUsers.length
            var selectedUsersToShow = []

            for (var i = 0; i < length; i++) {
                selectedUsersToShow[i] = state.checkedUsers[i]
            }

            //state.form.resources.sort( compare )

            return state.form.resources.filter(function(usr) {
                return selectedUsersToShow.includes(usr.role)
            })
        })

    })






    /* ************************************************************************ */
        const tableSort = reactive({
            asc: true,
            col: '',
        })

        // Function to sort Array of Resources
        function sortUsers(byKey, type ) {
            useArrayUtils.sortArrayForTables( state.form.resources, byKey, type, tableSort )
        }


        // Compare 2 data by specific attributes
    /*
        function compare( a, b ) {

            if ( a.name.toLowerCase() < b.name.toLowerCase() ) {
                return -1;
            }
            if ( a.name.toLowerCase() > b.name.toLowerCase() ) {
                return 1;
            }
            return 0;
        }
    */


    /* ************************************************************************ */






    // Flush all user's attributes
    function flushAttributes() {
        state.form.body.id = null
        state.form.body.name = ''
        state.form.body.email = ''
        state.form.body.password = ''
        state.form.body.role = 0
    }

    // Flush all user's attributes
    function initAttributes() {
        state.form.body.role = 0
    }


    function getUsers() {

        state.form.loading = true

        return useCrud.getAllResources({
            url: 'users'
        })
        .then((res) => {
            state.form.resources = res.data.data
            state.form.loading = false
            state.form.status = 'success'
        });
    }


    function getResourcesPaginate() {

        state.form.loading = true

        let nextPage = state.pagination.meta.requestedPage
        let nbPerPage = state.pagination.meta.requestQtyPerPage
        let requestUrl = 'users/paginate/' + nbPerPage + '?page=' + nextPage

        return useCrud.getResourcesWithPagination({
            url: requestUrl
        })
        .then((res) => {
            state.form.resources = res.data.data

            state.pagination.meta.total = res.data.meta.total
            state.pagination.meta.curentPage = res.data.meta.current_page
            state.pagination.meta.lastPage = res.data.meta.last_page
            state.pagination.meta.perPage = res.data.meta.per_page
            state.pagination.meta.to = res.data.meta.to
            state.pagination.meta.from = res.data.meta.from

            state.pagination.links.prev = res.data.links.prev
            state.pagination.links.next = res.data.links.next


            state.form.loading = false
            state.form.status = 'success'
        })

    }


    // Store new created resource to backend
    function searchResources(data) {

        useErrors.useResetErrors()
        state.form.status = 'saving'

        return useCrud.searchResources({
            url: 'users/search/' + data,
            resource: data
        })
        .then((res) => {
            state.form.resources = res.data.resources
            state.form.status = 'success'
            return res.data.resources
        })
    }


    function storeResource() {

        useErrors.useResetErrors()
        state.form.status = 'saving'

        return useCrud.storeResource({
            url: 'users',
            resource: state.form.body
        })
        .then((res) => {
            state.form.resources.push(res.data.resource)

            state.form.status = 'success'
            state.form.response.message = res.data.message
        })
    /*
        .catch((err) => {
            useErrors.useSetErrors(err.response.data)
        })
    */
    }

    function updateResource() {

        useErrors.useResetErrors()
        state.form.status = 'updating'

        let id = state.form.body.id

        return useCrud.updateResource({
            url: 'users/' + id,
            resource: state.form.body
        })
        .then((res) => {
            var index = state.form.resources.findIndex(x => x.id === res.data.resource.id)

            // if resource not existing in array
            if (index < 0) {
                // add resource to array
                state.form.resources.push(res.data.resource)
            } else {
                // update resource in array
                state.form.resources.splice(index, 1, res.data.resource)
            }

            state.form.status = 'success'

            state.form.response.message = res.data.message
            //state.form.response.alert = 'alert-success'

            //useMessages(res.data, 'alert-success')
        })
        /*
        .catch((err) => {
            useMessages(err.response.data, 'alert-danger')
        })
        */


    }



    function deleteResource(resource) {

        return useCrud.deleteResource({
            url: 'users/' + resource.id,
            resource: resource.id
        })
        .then(() => {
            var index = state.form.resources.findIndex(x => x.id === resource.id)
            state.form.resources.splice(index, 1)

            state.form.status = 'success'
        })

    }


    return {
        state,
        //useCrud,
        useErrors,
        //compare,
        flushAttributes,
        initAttributes,
        getUsers,
        getResourcesPaginate,
        searchResources,
        storeResource,
        updateResource,
        deleteResource,
        tableSort,
        sortUsers,
    }

}
